var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"autocomplete-wrapper"},[_c('autocomplete',{attrs:{"source":_vm.searchUrl,"results-display":_vm.formattedDisplay,"input-class":"autocomplete"},on:{"selected":_vm.onSelect}},[_vm._v(">\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }